import React from 'react';

const AccueilTrans = () => {
  return (
    <div className="Visa mg-top-120">
      <p>
        Dès votre arrivée à l&apos;aéroport, nous nous assurons que votre séjour
        commence sous les meilleurs auspices. Un accueil chaleureux vous attend
        dès que vous franchissez les portes de l&apos;aéroport, où notre équipe
        dédiée est là pour vous accueillir et faciliter votre transfert vers
        l&apos;hôtel. Notre service de transport confortable et sécurisé vous
        conduit directement à votre destination, vous offrant ainsi un début de
        séjour sans stress et en toute tranquillité. Profitez du trajet pour
        vous détendre et anticiper les merveilles que vous découvrirez lors de
        votre séjour parmi nous.
      </p>
    </div>
  );
};

export default AccueilTrans;
